document.addEventListener("DOMContentLoaded", () => {
	const animatedCarousels = document.querySelectorAll(".animated-carousel");

	if (animatedCarousels) {
		animatedCarousels.forEach((carousel) => {
			const imageSwiper = new Swiper(carousel.querySelector(".animated-carousel__image-swiper"), {
				// Optional parameters
				spaceBetween: 30,
				effect: "fade",
				keyboard: true,
				allowTouchMove: false,
				slidesPerView: 1,
			});

			const contentSwiper = new Swiper(carousel.querySelector(".animated-carousel__content-swiper"), {
				// Optional parameters
				spaceBetween: 30,
				effect: "fade",
				keyboard: true,
				allowTouchMove: false,
				slidesPerView: 1,

				// Navigation arrows
				navigation: {
					nextEl: carousel.querySelector(".animated-carousel__swiper-navigation .swiper-button-next"),
					prevEl: carousel.querySelector(".animated-carousel__swiper-navigation .swiper-button-prev"),
				},
				pagination: {
					el: carousel.querySelector(".animated-carousel__swiper-navigation .swiper-pagination"),
					type: "fraction",
				},
			});

			// synchronize the sliders
			imageSwiper.controller.control = contentSwiper;
			contentSwiper.controller.control = imageSwiper;
		});
	}
});
